import { Dispatch, FC, SetStateAction, useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router";
import { AuthContext } from "src/context/authContext";
import { LoaderContext } from "src/context/loaderContext";
import { ToastContext } from "src/context/toastContext";
import { handleNavigation } from "src/helpers";
// import { useNavigate } from "react-router-dom";

// import { ToastContext } from "src/context/toastContext";
import useCaseTransferFunc from "src/hooks/useCaseTransferFunc";
import useFetch from "src/hooks/useFetch";
import { ToastTypes } from "src/types";
import { APIEndpoints } from "src/types/apiTypes";



const RenderNextStep: FC<
  {
    showHideModalForTreatment: Dispatch<SetStateAction<{ isModalVisible: boolean; caseId: number; prescriptionId: number; title: string; bentype: string; investigated_at?: string }>>;
    setDataForCancelModal: Dispatch<SetStateAction<{ isModalVisible: boolean; caseId: number; prescriptionId: number; }>>;
    updateVisibilityOfTransferModal: Dispatch<SetStateAction<{ isModalVisible: boolean; caseId: number; precertId: number; }>>;
    updateClinicalDocumentModal: React.Dispatch<React.SetStateAction<{isModalVisible: boolean;caseId: number;precertId: number;}>>
    refreshListing: () => void;
    active_precert_id: number | null;
    prescription_id: number;
    investigated_at?: string;
    pending_precert_id: number | null;
    appeal_precert_id: number | null;
    case_id: number;
    pa_workflow_required: boolean;
    next_Steps: string[];
    action_Required: boolean;
    inOneLine?:boolean;
  }
> = ({ showHideModalForTreatment, setDataForCancelModal, updateClinicalDocumentModal, refreshListing, pa_workflow_required, active_precert_id, prescription_id, investigated_at, pending_precert_id, appeal_precert_id, case_id, next_Steps, action_Required ,inOneLine}): JSX.Element => {
  // const navigate = useNavigate();
  const { apiInPorgress: transferAPILoading, submitTransferCase } = useCaseTransferFunc({ redirectAction: () => refreshListing?.() });
  
  const { showToast } = useContext(ToastContext)
  const { setLoader, hideLoader } = useContext(LoaderContext)

  const navigate = useNavigate();
  const location = useLocation();
  const { defaultView, isManufacturer } = useContext(AuthContext);

  const redirectDecision = () => {
    const isRedirectRequired = handleNavigation(defaultView, location.pathname);
    if (isRedirectRequired) {
      navigate(defaultView.includes("/") ? defaultView : `/${defaultView}`, { replace: true })
    } else {
      refreshListing()
    }
  }

  // const navigateToPrecertPage = () => {
  //   navigate(`/cases/${case_id}/precerts/${active_precert_id}/edit`);
  // }

  const transferCase = (msg: string, transfer: boolean) => {
    // eslint-disable-next-line no-restricted-globals
    const res = confirm(msg);
    if (res) submitTransferCase(case_id, transfer)
  }

  const { data: transferRxData, mutate: transferRxByCaseId } =
    useFetch(APIEndpoints.TRANSFER_RX,);

  useEffect(() => {
    if (transferRxData) {
      const { message } = transferRxData as unknown as { code: number; message: string; };
      hideLoader()
      showToast([message], ToastTypes.SUCCESS);
      redirectDecision();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [transferRxData]);

  // useEffect(() => {
  //   if (transferRxLoading) setLoader();
  //   else hideLoader();
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [transferRxLoading]);

  const confirmAlertForXfer = (title: string) => {
    const result = window.confirm(title);
    if (result) {
      setLoader();
      transferRxByCaseId({}, { case_id }, { rep_xfer: true })
    }
  }


  if (next_Steps && next_Steps.length > 0) {
    const caseAction: JSX.Element[] = [];
    next_Steps.forEach((step, index) => {
      if (step === "Treated") {
        caseAction.push(
          <button key={index} className="btn btn-green btn-sm rounded-0 m-1" type="button" 
            onClick={() => showHideModalForTreatment({ 
              caseId: case_id, isModalVisible: true, prescriptionId: prescription_id, title: "Date of Treatment", bentype: isManufacturer ? "med" : "na", 
              investigated_at 
            })}
          >
            <i className="far fa-clipboard"></i> Treated
          </button>
        );
      } else if (step === "Treatment Scheduled") {
        caseAction.push(
          <button
            key={index}
            className="btn btn-green btn-sm rounded-0 m-1"
            type="button"
            onClick={() =>
              showHideModalForTreatment({
                caseId: case_id,
                isModalVisible: true,
                prescriptionId: prescription_id,
                title: "Scheduled Date of Treatment",
                bentype: "sd",
              })
            }
          >
            <i className="fa fa-times"></i> Treatment Scheduled
          </button>
        );
      } else if (step === "Not Treating" || step === "Not Treated") {
        caseAction.push(
          <button
            key={index}
            onClick={() =>
              setDataForCancelModal({
                caseId: case_id,
                isModalVisible: true,
                prescriptionId: prescription_id,
              })
            }
            className="btn btn-green btn-sm rounded-0 m-1"
            type="button"
          >
            <i className="fa fa-times"></i> Not Treating
          </button>
        );
      } else if (step === "Precert") {
        // caseAction.push(
        //   <button
        //     key={index}
        //     className="btn btn-sm background-color-5 my-1 text-white"
        //     type="button"
        //     onClick={() => showToast(["Precert not found!"], ToastTypes.ERROR)}
        //   >
        //     <i className="fas fa-clipboard-list"></i> Precert
        //   </button>
        // );
      } else if (
        step === "Transferred to other Specialty Pharmacy" ||
        step === "Transferred"
      ) {
        caseAction.push(
            <div>
                <button
                    key={index}
                    className="btn btn-green btn-sm background-color-2 rounded-0 m-1 text-white"
                    type="button"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title="Clicking this button indicates your office has already transferred this case to a local pharmacy"
                    onClick={() => {
                      if (step === "Transferred to other Specialty Pharmacy") {
                        if (pa_workflow_required) {
                          updateClinicalDocumentModal({ isModalVisible: true, caseId: case_id, precertId: active_precert_id || 0 })
                        } else {
                          transferCase("ALERT: Clicking this button indicates your office has already transferred this case to a local pharmacy outside of MQC. Your office will be responsible for any PA requirements as well as follow up with that pharmacy",true)
                        }
                      } else if (step === "Transferred") {
                        confirmAlertForXfer(
                          "By clicking this you are noting the office has transferred this prescription to a Specialty Pharmacy. Are you sure you want to mark this prescription transferred? This cannot be undone!",
                        )
                      }
                    }}
                    disabled={transferAPILoading}
                >
                    <i className="fas fa-prescription"></i> {step}
                </button>
            </div>
        );
      } else if (step === "Transfer to CenterWell" || step === "Transfer to Knipper"  || step === "Transfer to Alliance Rx Walgreens") {
        caseAction.push(
          <button
            key={index}
            className="btn btn-green btn-sm background-color-2 rounded-0 m-1"
            type="button"
            data-bs-toggle="tooltip"
            data-bs-placement="top"
            title="Clicking this button will transfer the prescription through the Specialty Pharmacy Channel"
            onClick={() => {
              if (step === "Transfer to CenterWell") {
                if (pa_workflow_required)
                  updateClinicalDocumentModal({ isModalVisible: true, caseId: case_id, precertId: active_precert_id || 0 })
                else
                  transferCase("Are you sure you want to transfer this prescription? This cannot be undone!", true)
              } else {
                transferCase("Are you sure you want to transfer this prescription? This cannot be undone!", true)
              }
            }}
            disabled={transferAPILoading}
          >
            <i className="fas fa-prescription"></i> {step}
          </button>
        );
      } else if (step.includes("Scheduled Tx Date")) {
        caseAction.push(
          <a
            href="."
            key={index}
            onClick={(e) => {
              e.preventDefault();
              showHideModalForTreatment({
                caseId: case_id,
                isModalVisible: true,
                prescriptionId: prescription_id,
                title: step,
                bentype: "sd",
              })
            }}
          >
            {step}
          </a>
        );
      } else if (step === "No Action Required") {
        caseAction.push(<p key={index} className="m-0">{step}</p>);
      }
    })

     return (
      <div
        className={inOneLine ? "d-flex flex-wrap align-items-center" : ""}
        style={inOneLine ? { gap: "6px" } : {}}
        key={0}
      >
        {caseAction}
      </div>
    );
  }
  else {
    return <span></span>
  }
};

export default RenderNextStep;

